import React from "react";
import { TextField, Grid2 } from "@mui/material";
import CollapsibleFormElement from "../../common/collapsible-form-element";

type ArchetypeScore = {
  key: string;
  label: string;
  value: number;
};

type ArchetypeScoresProps = {
  scores: Record<string, number>;
  onChange: (key: string, value: number) => void;
};

const ArchetypeScores: React.FC<ArchetypeScoresProps> = ({
  scores,
  onChange,
}) => {
  const formatScores = (): ArchetypeScore[] => {
    return Object.entries(scores)
      .filter(([key]) => key.startsWith("archetype_score_"))
      .map(([key, value]) => ({
        key,
        label: key
          .replace("archetype_score_", "")
          .split("_")
          .map((word) => word.charAt(0).toUpperCase() + word.slice(1))
          .join(" "),
        value: value || 0,
      }));
  };

  const archetypeScores = formatScores();

  return (
    <CollapsibleFormElement title="Archetype Scores">
      <Grid2 container spacing={2}>
        {archetypeScores.map((score) => (
          <Grid2 size={{ xs: 6, md: 3 }} key={score.key}>
            <TextField
              fullWidth
              label={score.label}
              type="number"
              value={score.value}
              onChange={(e) =>
                onChange(score.key, parseFloat(e.target.value) || 0)
              }
              slotProps={{
                htmlInput: {
                  min: 0,
                  max: 10,
                  step: 1,
                },
              }}
              size="small"
            />
          </Grid2>
        ))}
      </Grid2>
    </CollapsibleFormElement>
  );
};

export default ArchetypeScores;
